module.exports = "/images/vendor/@sellers-shield-home-protection/ss-ui-kit/src/static/logo.png?3d1d884542b6c93b1e217c5a118453c3";